import React, {useEffect, useRef} from 'react';
import SearchAssistModal from "./ui/modal/SearchAssistModal";
import Search from "../../features/productSearch/ui/search/Search";
import {useProductSearchStore} from "../../features/productSearch/model/store";
import {useSearchWidgetStartPosition} from "./hook/useSearchWidgetStartPosition";
import {useClickOutside} from "../../shared/hook/useClickOutside";
import SuggestionList from "../../features/productSearch/ui/suggestions/SuggestionList";
import ModalProductSearchWidget from "./widget/ModalProductSearchWidget";
import {GLOBAL_STYLE_CONFIG} from "../../app/styles/GlobalStyles";
import {ErrorBoundary} from "../../shared/ui/ErrorBoundary";

const SearchWidgetRoot = () => {
    const {inputRef, modalPosition, isOpen, openModal, closeModal} = useSearchWidgetStartPosition()
    const {products, resetSearch} = useProductSearchStore();

    useEffect(() => {
        if (Array.isArray(products) && products?.length && !isOpen) {
            openModal();

        }
    }, [products]);
    //Нужно дабавить логику при закрытии модального окна сбрасывать стор поиска
    const onCloseAndResetSearch = () => {
        closeModal();
        resetSearch();
    }

    const modalRef = useRef(null);
    /**
     * Hook в который передаем массив ref, что бы при клике вне этих дом елементов
     * модальоное окно закрылось
     */
    useClickOutside([modalRef, inputRef], () => {
        onCloseAndResetSearch()
    });
    return (
        <>
            <ErrorBoundary>
                <Search ref={inputRef}/>
            </ErrorBoundary>

            <SearchAssistModal modalPosition={modalPosition} isOpen={isOpen}
                               modalRef={modalRef}
                               onClose={onCloseAndResetSearch}
                               slotSuggestion={<SuggestionList/>}
            >
                <ErrorBoundary>
                    <ModalProductSearchWidget/>
                </ErrorBoundary>
            </SearchAssistModal>

        </>
    );
};

export default SearchWidgetRoot;